import { errorsEndPoint, useAppMutation } from '@alluradirect/react';

interface Values {
  client_ip: number;
  user_id: number;
  user_type_id: number;
  stack_trace: string;
  message: string;
}

export const useErrorsMutation = () => {
  return useAppMutation<Values>({
    url: errorsEndPoint,
    method: 'POST',
    hasToastsEnabled: false,
  });
};
